module.exports = __webpack_public_path__ + "static/media/white_shred.34a4de15.png";